const BASE_URL = '/api/v1';

export const AUTH_ENDPOINT = `${BASE_URL}/auth`;

export const OAUTH_ENDPOINT = `${BASE_URL}/oauth`;

export const COMPANIES_ENDPOINT = `${BASE_URL}/companies`;

export const SFTP_ENDPOINT = `${BASE_URL}/sftp`;
